import { ref } from "vue";
import { createApiClient } from "#/shared/api/client";

const api = createApiClient({ parse: false });

const formElement = ref();

export function useWaitlistStore() {
  function isValid() {
    formElement.value.reportValidity();
    return formElement.value.checkValidity();
  }

  async function submitForm() {
    const url = formElement.value.action;

    const formData = new FormData(formElement.value);

    formData.append("waitlist", "true");

    const data = await api.post(url, formData);

    return data.confirmation_url;
  }

  function reset() {
    formElement.value?.reset();
  }

  return {
    setFormElement: (element) => (formElement.value = element),

    get formElement() {
      return formElement.value;
    },

    isValid,
    submitForm,
    reset,
  };
}
